var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdfLink"},[_c('pdfLink',{attrs:{"href":'https://finmoll.ru/backend/content/documents/certificate_ooo_finmoll',"title":'Свидетельство ООО МКК «ФИНМОЛЛ»'}}),_c('pdfLink',{attrs:{"href":'https://finmoll.ru/backend/content/documents/certificate_sro_mir',"title":'Свидетельство членства СРО МИР'}}),_c('a',{attrs:{"href":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }